import { render, staticRenderFns } from "./DuwaServices.vue?vue&type=template&id=6eb45ad6"
import script from "./DuwaServices.vue?vue&type=script&lang=js"
export * from "./DuwaServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports